module.exports = __webpack_public_path__ + "static/Kratos_main_white-ec101b686683508045585c4d6bf5e572.png";